import { api, endpoints } from "./api";

export interface StaticFile {
  id: number;
  fileName: string;
  contentType: string;
  fileSize: number;
  publicPath: string;
  publicUrl: string;
  uploadedAt: Date;
}

export const staticFilesApi = {
  getAll: async (): Promise<StaticFile[]> => {
    const response = await api.get<StaticFile[]>(endpoints.STATIC_FILES.GET());
    return response.data;
  },

  upload: async (file: File, publicPath?: string): Promise<StaticFile> => {
    const formData = new FormData();
    formData.append("file", file);
    if (publicPath) {
      formData.append("publicPath", publicPath);
    }

    const response = await api.post<StaticFile>(endpoints.STATIC_FILES.UPLOAD(), formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  },

  delete: async (id: number): Promise<void> => {
    await api.delete(endpoints.STATIC_FILES.DELETE(id));
  },
};
